var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/landing-gradient.tsx";
import React from 'react';
/** Fullscreen gradient used as a backdrop to public pages. */

const LandingGradient = () => /*#__PURE__*/React.createElement("div", {
  className: "fixed h-screen w-full bg-gradient-to-tr from-primary-50 dark:from-primary-900/50 via-white dark:via-primary-900 to-gradient-end/10 dark:to-primary-800/50",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 5,
    columnNumber: 3
  }
});

export default LandingGradient;